import * as React from 'react';
import { Create } from 'react-admin';
import { PresetForm } from './PresetForm';

export const PresetCreate = (props: any) => (
  <Create {...props}>
    <PresetForm />
  </Create>
);
